import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser'
import parse, { Element, domToReact } from 'html-react-parser'
import React from 'react'
import { Link } from 'react-router-dom'

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.name === 'a' && domNode.attribs?.href) {
      const { href } = domNode.attribs

      const getPathFromUrl = (url: string): string => {
        try {
          const urlObj = new URL(url)

          return urlObj.pathname + urlObj.search + urlObj.hash
        } catch {
          return url
        }
      }

      const path = getPathFromUrl(href)

      return <Link to={path}>{domToReact(domNode.children as DOMNode[], options)}</Link>
    }
  },
}

export const HtmlWithLinks = ({ html }: { html: string }) => {
  return parse(html, options)
}
